// extracted by mini-css-extract-plugin
export default {"pdf-holder":"R3XaB","big-button":"iv8kY","right-branding":"FNcxG","bottom-branding":"C6VXW","bottom-branding--mobile":"F1bFu","sticky-branding":"YITQA","error-box":"dJBDR"};